module.exports = __webpack_public_path__ + "img/Questionnaire.2b0528ef.png";